export const SET_HOLDERS_ERROR = 'SET_HOLDERS_LIST_ERROR';
export const SET_FETCHING_PARENT_HOLDERS = 'SET_FETCHING_PARENT_HOLDERS';
export const SET_PARENT_HOLDERS = 'SET_PARENT_HOLDERS';
export const SET_FETCHING_ACCOUNT_MANAGERS = 'SET_FETCHING_ACCOUNT_MANAGERS';
export const SET_ACCOUNT_MANAGERS = 'SET_ACCOUNT_MANAGERS';
export const SET_HOLDER_CHILDREN = 'SET_HOLDER_CHILDREN';